import angular from 'angular';

export class LoginService {
    constructor(AppUserService) {
        'ngInject';
        this.AppUserService = AppUserService;
    }

    login(email, password) {
        return this.AppUserService.loginUser(email, password);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.service.js